export const isNumber = (value: any) => !Number.isNaN(parseInt(value, 10));
